import { ChangePasswordState } from './changePassword.types'

const initialState: ChangePasswordState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
